// @owners { team: patients-team }
import { COLORS } from '@alto/design-library-tokens';
import { Description, ExternalLink, type TextSize } from '@alto/design-system';
import React from 'react';
import { getUserSupportPhone } from '~shared/features/users/selectors/getUserSupportPhone';
import { getCurrentUserID } from '~shared/features/users/selectors/getUsers';
import { stripNonDigits } from '~shared/helpers/string';
import { useAnalytics } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { useSelectorShared } from '~shared/store';

export type Props = {
  readonly origin?: string; // pass in when phone number is a link (default)
  readonly asLink?: boolean;
  readonly textSize?: TextSize;
};

export function AltoPhoneNumber({ origin, asLink = true, textSize = 'mini' }: Props) {
  const currentUserID = useSelectorShared(getCurrentUserID);
  const phoneNumber = useSelectorShared((state) => getUserSupportPhone(state, { userID: currentUserID }));
  const { trackEvent } = useAnalytics();

  const onPress = () => {
    trackEvent({
      event: EVENTS.CALL_US_CLICKED,
      params: {
        origin,
        phoneNumber,
        web: false,
      },
    });
  };

  // Use non breaking space to prevent phone number wrapping
  const phoneNumberDisplay = phoneNumber.replace(/ /g, '\u00a0');

  if (asLink) {
    return (
      <ExternalLink
        href={`tel://${stripNonDigits(phoneNumber)}`}
        onPress={onPress}
        textSize={textSize}
      >
        {phoneNumberDisplay}
      </ExternalLink>
    );
  }

  return <Description color={COLORS.TEXT_COLORS.BLACK}>{phoneNumberDisplay}</Description>;
}
